/**
 * @generated SignedSource<<e464d07742c384279ee271fe9a9be56a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetCalendarInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds?: ReadonlyArray<string> | null;
};
export type WACalendarMutation$variables = {
  input: CreateWidgetCalendarInput;
  storecastId: string;
};
export type WACalendarMutation$data = {
  readonly dashboard: {
    readonly createWidgetCalendar: {
      readonly id: string;
    };
  };
};
export type WACalendarMutation = {
  response: WACalendarMutation$data;
  variables: WACalendarMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetCalendar",
        "kind": "LinkedField",
        "name": "createWidgetCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WACalendarMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WACalendarMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b330d72ff44b7ae53aaeb74f99fa94b1",
    "id": null,
    "metadata": {},
    "name": "WACalendarMutation",
    "operationKind": "mutation",
    "text": "mutation WACalendarMutation(\n  $storecastId: ID!\n  $input: CreateWidgetCalendarInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetCalendar(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6fb43334a793cdf65ce91ea4588b362";

export default node;
